// removed by extract-text-webpack-plugin
module.exports = {"Fieldset":"Fieldset","fieldset":"Fieldset","Fieldset__legend":"Fieldset__legend","fieldsetLegend":"Fieldset__legend","Fieldset__legend__icon":"Fieldset__legend__icon","fieldsetLegendIcon":"Fieldset__legend__icon","Fieldset__legend__heading":"Fieldset__legend__heading","fieldsetLegendHeading":"Fieldset__legend__heading","Fieldset__content":"Fieldset__content","fieldsetContent":"Fieldset__content"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/search/SearchForm/Fieldset.scss
// module id = 608
// module chunks = 0